import { render } from "@/components/pages/obd/obdIndividualMenu/ObdIndividualMenu.html?vue&type=template&id=53327813&external"
import script from "@/components/pages/obd/obdIndividualMenu/ObdIndividualMenu.js?vue&type=script&lang=js&external"
export * from "@/components/pages/obd/obdIndividualMenu/ObdIndividualMenu.js?vue&type=script&lang=js&external"

import "@/components/pages/obd/obdIndividualMenu/ObdIndividualMenu.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__